import { render, staticRenderFns } from "./policyList.vue?vue&type=template&id=56e5167a&scoped=true&"
import script from "./policyList.vue?vue&type=script&lang=js&"
export * from "./policyList.vue?vue&type=script&lang=js&"
import style0 from "./policyList.vue?vue&type=style&index=0&id=56e5167a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e5167a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e5167a')) {
      api.createRecord('56e5167a', component.options)
    } else {
      api.reload('56e5167a', component.options)
    }
    module.hot.accept("./policyList.vue?vue&type=template&id=56e5167a&scoped=true&", function () {
      api.rerender('56e5167a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/policyList.vue"
export default component.exports